module.exports = __webpack_public_path__ + "img/logo3.e5292603.png";